import React from 'react';
import { IFormulaItemData } from '../../../ModelBuilderContext';
import Typography from '~/components/Typography';
import IsolatedPopover from './IsolatedPopover';
import quickbooksIcon from '~/assets/logos/quickbooks.svg';
import xeroIcon from '~/assets/logos/xero.svg';
import ColumnResize from '~/components/FormulasTable/ColumnResize';

interface IProps {
  rowIndex: number;
  columnWidth: number;
  data: IFormulaItemData;
  columnIndex: number;
}

const integrationIconMapping = {
  'quickbooks-online': quickbooksIcon,
  xero: xeroIcon,
};

const Label = ({ columnWidth, data, columnIndex }: IProps): React.ReactElement => {
  return (
    // TODO - Move the sort drag handle inside of this component for better readbility
    <div
      className="relative flex pr-2 py-3 border-r border-neutral-50 text-nowrap"
      style={{ width: `${columnWidth}px`, minWidth: `${columnWidth}px` }}
    >
      <div className="flex w-full overflow-hidden">
        <Typography>{data.label.name}</Typography>
      </div>
      <div className="absolute right-0 flex items-center gap-1 bg-white px-2">
        {data.label.isIsolated && <IsolatedPopover />}
        {data.label.integration && (
          <div key={`${data.formulaUuid}-${data.label.integration}`}>
            <img
              className="size-5"
              src={integrationIconMapping[data.label.integration as keyof typeof integrationIconMapping]}
              alt={`Integration icon for ${data.label.integration}`}
            />
          </div>
        )}
      </div>
      <ColumnResize columnIndex={columnIndex} />
    </div>
  );
};

export default Label;
